import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Field, FieldDescription, FieldGroup, FieldLabel } from "@/components/ui/field"
import { Input } from "@/components/ui/input"
import { registerUser } from "@/lib/auth"

export function Register({ className, ...props }: React.ComponentProps<typeof Card>) {
  const navigate = useNavigate()
  const [fullName, setFullName] = useState("")
  const [email, setEmail] = useState("")
  const [dniOrSsn, setDniOrSsn] = useState("")
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState("")

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    setError("")

    if (password.length < 8) {
      setError("La contraseña debe tener al menos 8 caracteres.")
      return
    }

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.")
      return
    }

    const result = await registerUser({
      fullName,
      email,
      dniOrSsn,
      password,
    })

    if (!result.ok) {
      setError(result.error)
      return
    }

    navigate("/login", {
      replace: true,
      state: { message: "Registro completado. Por favor, inicia sesión." },
    })
  }

  return (
    <div className="mx-auto flex min-h-screen w-full max-w-md items-center px-4">
      <Card className={className} {...props}>
        <CardHeader>
          <CardTitle>Crear una cuenta</CardTitle>
          <CardDescription>
            Ingresa tu información a continuación para crear tu cuenta
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <FieldGroup>
              {error ? <FieldDescription className="text-destructive">{error}</FieldDescription> : null}
              <Field>
                <FieldLabel htmlFor="name">Nombre Completo</FieldLabel>
                <Input
                  id="name"
                  type="text"
                  placeholder="Juan Pérez"
                  value={fullName}
                  onChange={(event) => setFullName(event.target.value)}
                  required
                />
              </Field>
              <Field>
                <FieldLabel htmlFor="email">Correo Electrónico</FieldLabel>
                <Input
                  id="email"
                  type="email"
                  placeholder="m@ejemplo.com"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
                <FieldDescription>
                  Usaremos esto para contactarte y autenticar tu cuenta.
                </FieldDescription>
              </Field>
              <Field>
                <FieldLabel htmlFor="dni-ssn">Cédula / DNI / SSN</FieldLabel>
                <Input
                  id="dni-ssn"
                  type="text"
                  placeholder="ID-123456"
                  value={dniOrSsn}
                  onChange={(event) => setDniOrSsn(event.target.value)}
                  required
                />
              </Field>
              <Field>
                <FieldLabel htmlFor="password">Contraseña</FieldLabel>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  required
                />
                <FieldDescription>
                  Debe tener al menos 8 caracteres.
                </FieldDescription>
              </Field>
              <Field>
                <FieldLabel htmlFor="confirm-password">
                  Confirmar Contraseña
                </FieldLabel>
                <Input
                  id="confirm-password"
                  type="password"
                  value={confirmPassword}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                  required
                />
                <FieldDescription>Por favor confirma tu contraseña.</FieldDescription>
              </Field>
              <FieldGroup>
                <Field>
                  <Button type="submit">Crear Cuenta</Button>
                  <Button variant="outline" type="button" onClick={() => navigate("/login")}>
                    Iniciar Sesión
                  </Button>
                  <FieldDescription className="px-6 text-center">
                    Los nuevos registros se crean con el rol de Afiliado.
                  </FieldDescription>
                </Field>
              </FieldGroup>
            </FieldGroup>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
